import { MasterTranslation } from '@/constants';
import { useGlobalState, useResponsive, useStatsigLayer } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { useMyParcelsContext } from '@/modules/pmt/context';

export const useAnonymousESBannerCopy = () => {
  const { t } = useGlobalState();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const { notificationTranslation } = useMyParcelsContext();
  const { get, isReady } = useStatsigLayer('track_my_parcel_copy_layer');

  const { emailSyncButtonText, emailSyncDesktopMainText, emailSyncMobileMainText } = notificationTranslation;

  const fallback = {
    newLabel: t(MasterTranslation.New),
    description: (isDesktopPMT ? emailSyncDesktopMainText : emailSyncMobileMainText) ?? '',
    cta: emailSyncButtonText ?? '',
  };

  if (!isReady) return fallback;

  return {
    newLabel: get('ems_banner_new_label', fallback.newLabel),
    description: get('ems_banner_description', fallback.description),
    cta: get('ems_banner_cta', fallback.cta),
  };
};
